import areaApi from '@/api/config/areaApi'
import { queryKeys } from '@/constant/common'
import { UpdateArea } from '@/types/areaZone'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function updateAreaItem(payload: UpdateArea): Promise<void> {
  await areaApi.updateArea(payload)
}

function useUpdateArea() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: UpdateArea) => updateAreaItem(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.areaZone])
      toast.success(t('editAreaSuccess'))
      closeSidebar()
    },
    onError: (error: any) => {
      toast.error(error?.message)
    },
  })
}

export default useUpdateArea
